import React from 'react'
import card1 from '../../assets/landing/card-11.jpg'
import card2 from '../../assets/landing/card-12.png'
import card3 from '../../assets/landing/card-13.png'
import greaterthan from '../../assets/general/greater-than-icon.svg'


const Expertise = () => {

  return (
    <div className='overflow-x-hidden no-scrollbar' >
      <div className='h-[80vh] overflow-x-hidden no-scrollbar lg:h-[120vh] bg-[#d9dadc]' >
        <div className='h-[80vh] lg:h-[120vh] bg-expertise-bg bg-cover bg-left md:bg-center lg:bg-center' >
            <div data-aos="fade-up" className='flex flex-col h-full pt-32 lg:pt-0 lg:justify-center px-6 relative  lg:ml-32 lg:w-[40%] 3xl:ml-[15vw]' >
              <h1 className='text-[#ff1f2b] text-6xl md:text-8xl lg:text-7xl font-mosk700 ' >
                Experts <span className='text-4xl md:text-5xl lg:text-4xl font-mosk600 ' >in </span> <br />
                Immersive <p className='text-4xl md:text-5xl lg:text-4xl font-mosk600' >Events</p>
              </h1>
              <div className='flex gap-x-6 pt-4 pb-6 pl-2' >
                <div className='w-2 h-2 bg-[#333942] rounded-full' ></div>
                <div className='w-2 h-2 bg-[#333942] rounded-full' ></div>
                <div className='w-2 h-2 bg-[#333942] rounded-full' ></div>
                <div className='w-2 h-2 bg-[#333942] rounded-full' ></div>
                <div className='w-2 h-2 bg-[#333942] rounded-full' ></div>
                <span></span>
              </div>
              <div className='flex items-center gap-2'>
                  <h3 className='text-[#0095da] text-3xl md:text-5xl lg:text-4xl font-mosk600' >Experience</h3>
                    <img className='w-[30px] ' src={greaterthan} alt="greater than icon" />
                  <h3 className='text-[#ff1f2b] text-3xl md:text-5xl lg:text-4xl font-mosk600' >Events</h3>
              </div>
            </div>
        </div>
      </div>

      <div className='bg-[#48e4bc]  !h-fit lg:h-[140vh]' >
        <div className=' z-12 flex flex-col items-center gap-y-[5vh] w-full px-6 lg:px-32 relative top-[-10vh] md:top-[-20vh]' >

            <div data-aos="fade-left" className='flex flex-col lg:flex-row h-fit  lg:min-h-[40vh]  w-full md:w-[80%] 3xl:w-[70%] lg:w-full lg:!h-[50vh] 3xl:!h-[40vh]' > 
              <div className='h-[30vh] w-[100%] lg:w-[40%] lg:h-full' style={{background: `url(${card1})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}></div>
              {/* <img className='lg:w-[40%] lg:h-full' src={card1} alt="" /> */}
              <div className='bg-[#ff1f2b] lg:w-[60%] flex flex-col gap-2 justify-center px-6 py-4 md:px-12 h-full' >
                <h3 className='text-[#fff] text-3xl font-mosk600' >Connect & Conquer</h3>
                <div  className='lg:max-h-[30vh] lg:overflow-y-scroll no-scrollbar'>
                  <p className='text-[#fff] text-lg md:text-md lg:text-xl lg:text-xlfont-mosk300 ' >We fuse innovation with creativity, focusing on collaboration to execute strategies that align with the company's vision and investments. This is out Tenet.</p>
                </div>
              </div>
            </div>

            <div data-aos="fade-right" className='flex flex-col-reverse lg:flex-row h-fit lg:min-h-[40vh] w-full md:w-[80%] 3xl:w-[70%] lg:w-full lg:!h-[50vh] 3xl:!h-[40vh]' > 
              <div className='bg-[#2f195e] lg:w-[60%] flex flex-col gap-2 justify-center px-6 py-4 md:py-12  lg:py-0 md:px-12 h-full ' >
                <h3 className='text-[#fff] text-3xl font-mosk600'>Experiential Branding</h3>
                <div className='lg:max-h-[30vh] lg:overflow-y-scroll no-scrollbar'>
                  <p className='text-[#fff] text-lg md:text-lg lg:text-md text-lg  lg:text-xlfont-mosk300'>We all experience the world through our five senses every day, and that's exactly what we aim to capture in our events. At Bluedoor, we take what makes your brand unique and combine it with the latest technology and traditional methods. Our goal is to create unforgettable experiences with a touch of creativity, bringing your brand to life in a way that truly resonates with people.</p>
                </div>
              </div>

             

              <div className='h-[30vh] w-[100%] lg:w-[40%] lg:h-full' style={{background: `url(${card2})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}></div>

              {/* <img className='h-[25vh] lg:h-full lg:w-[40%]' src={card2} alt="" /> */}
            </div>
      
            <div data-aos="fade-left" className='flex flex-col lg:flex-row h-fit  w-full md:w-[80%] 3xl:w-[70%] lg:w-full lg:!h-[50vh] 3xl:!h-[40vh]' > 
              <div className='h-[30vh] w-[100%] lg:w-[40%] lg:h-full' style={{background: `url(${card3})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}></div>
              {/* <img className='lg:w-[40%] lg:!h-full' src={card3} alt="" /> */}
              <div className='bg-[#0095da] lg:w-[60%] flex flex-col gap-2 justify-center px-6 py-4 md:py-12 lg:py-0 md:px-12 h-full' >
                <h3 className='text-[#fff] text-3xl font-mosk600'>Influential Content Development</h3>
                <div  className='lg:max-h-[30vh] lg:overflow-y-scroll no-scrollbar'>
                  <p className='text-[#fff] text-lg md:text-lg lg:text-md text-lg lg:text-xlfont-mosk300'>Every journey tells a story, shaped by process and teamwork. Our leadership excels in creating communication strategies that elevate both customer and employee experiences. Whether through print or media, effective brand communication requires the expertise of seasoned professionals. At Bluedoor, we understand this deeply and are committed to making your brand's story shine.</p>

                </div>
              </div>
            </div>

        </div>
      </div>

      
      
    </div>
  )
}

export default Expertise
